import * as actions from "../action.constants";

const initialState = {
  isLoading: false,
  dashboard_list: [],
};

const dashboardDataRecieved = (state, action) => {
  return {
    ...state,
    dashboard_list: action.responsePayload,
  };
};

const handlers = {
  [actions.SAVE_CARD_DATA]: dashboardDataRecieved,
};

export default (state = initialState, action) => {
  const handler = handlers[action.type];
  if (typeof handler === "undefined") return state;
  return handler(state, action);
};
